import React, { useMemo } from 'react';
import { LightAsync as SyntaxHighlighter } from 'react-syntax-highlighter';
import bashLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/bash';
import jsLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/javascript';
import rubyLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/ruby';
import pythonLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/python';
import goLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/go';
import phpLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/php';
import javaLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/java';
import cSharpLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/cs';
import jsonLang from 'react-syntax-highlighter/dist/cjs/languages/hljs/json';
import { decodeEntities } from '../../utils';
import { StyledCode } from './styles';

SyntaxHighlighter.registerLanguage('curl', bashLang);
SyntaxHighlighter.registerLanguage('node.js', jsLang);
SyntaxHighlighter.registerLanguage('ruby', rubyLang);
SyntaxHighlighter.registerLanguage('python', pythonLang);
SyntaxHighlighter.registerLanguage('go', goLang);
SyntaxHighlighter.registerLanguage('php', phpLang);
SyntaxHighlighter.registerLanguage('java', javaLang);
SyntaxHighlighter.registerLanguage('c#', cSharpLang);
SyntaxHighlighter.registerLanguage('json', jsonLang);

const Code = ({ children, language, ...props }) => {
  /**
   * Advanced Custom Fields encodes php, so we have to decode
   * special characters before passing to syntax highlighter
   */
  const code = useMemo(() => {
    if (language !== 'php') return children;
    return decodeEntities(children);
  }, [language]);

  return (
    <SyntaxHighlighter
      language={language}
      useInlineStyles={false}
      showLineNumbers
      PreTag={StyledCode}
      {...props}
    >
      {code}
    </SyntaxHighlighter>
  );
};

export default Code;
